import { Routes, Route, Navigate } from 'react-router-dom';
import useAuth from 'hooks/useAuth';

import IndexLayout from 'layouts/IndexLayout';
import MainLayout from 'layouts/MainLayout';
import AuthRoutes from 'components/AuthRoutes';
import IndexPage from 'pages/index/IndexPage';
import AlldatatblList from 'pages/alldatatbl/List';
import AlldatatblView from 'pages/alldatatbl/View';
import AlldatatblAdd from 'pages/alldatatbl/Add';
import AlldatatblEdit from 'pages/alldatatbl/Edit';
import EmailopenlogsList from 'pages/emailopenlogs/List';
import EmailopenlogsView from 'pages/emailopenlogs/View';
import EmailopenlogsAdd from 'pages/emailopenlogs/Add';
import EmailopenlogsEdit from 'pages/emailopenlogs/Edit';
import PermissionsList from 'pages/permissions/List';
import PermissionsView from 'pages/permissions/View';
import PermissionsAdd from 'pages/permissions/Add';
import PermissionsEdit from 'pages/permissions/Edit';
import RolesList from 'pages/roles/List';
import RolesView from 'pages/roles/View';
import RolesAdd from 'pages/roles/Add';
import RolesEdit from 'pages/roles/Edit';
import TempletemasterList from 'pages/templetemaster/List';
import TempletemasterView from 'pages/templetemaster/View';
import TempletemasterAdd from 'pages/templetemaster/Add';
import TempletemasterEdit from 'pages/templetemaster/Edit';
import UsersList from 'pages/users/List';
import UsersView from 'pages/users/View';
import UsersAdd from 'pages/users/Add';
import UsersEdit from 'pages/users/Edit';
import SendmailPage from 'pages/custom/SendmailPage';
import BulkupdatetempletePage from 'pages/custom/BulkupdatetempletePage';
import AccountPages from 'pages/account';
import HomePage from './pages/home/HomePage';
import IndexPages from './pages/index';
import ErrorPages from './pages/errors';
import 'primereact/resources/primereact.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import 'assets/styles/layout.scss';
const App = () => {
	const auth = useAuth();
	function DefaultPage(){
		if(!auth.isLoggedIn){
			return <IndexPage />
		}
		return <Navigate to="/home" replace />;
	}
	return (
		<Routes>
			<Route exact element={<AuthRoutes />}>
			<Route element={<MainLayout />}>
				<Route path="/home" element={<HomePage />} />
				

				{/* alldatatbl pages routes */}
				<Route path="/alldatatbl" element={<AlldatatblList />} />
				<Route path="/alldatatbl/:fieldName/:fieldValue" element={<AlldatatblList />} />
				<Route path="/alldatatbl/index/:fieldName/:fieldValue" element={<AlldatatblList />} />
				<Route path="/alldatatbl/view/:pageid" element={<AlldatatblView />} />
				<Route path="/alldatatbl/add" element={<AlldatatblAdd />} />
				<Route path="/alldatatbl/edit/:pageid" element={<AlldatatblEdit />} />

				{/* emailopenlogs pages routes */}
				<Route path="/emailopenlogs" element={<EmailopenlogsList />} />
				<Route path="/emailopenlogs/:fieldName/:fieldValue" element={<EmailopenlogsList />} />
				<Route path="/emailopenlogs/index/:fieldName/:fieldValue" element={<EmailopenlogsList />} />
				<Route path="/emailopenlogs/view/:pageid" element={<EmailopenlogsView />} />
				<Route path="/emailopenlogs/add" element={<EmailopenlogsAdd />} />
				<Route path="/emailopenlogs/edit/:pageid" element={<EmailopenlogsEdit />} />

				{/* permissions pages routes */}
				<Route path="/permissions" element={<PermissionsList />} />
				<Route path="/permissions/:fieldName/:fieldValue" element={<PermissionsList />} />
				<Route path="/permissions/index/:fieldName/:fieldValue" element={<PermissionsList />} />
				<Route path="/permissions/view/:pageid" element={<PermissionsView />} />
				<Route path="/permissions/add" element={<PermissionsAdd />} />
				<Route path="/permissions/edit/:pageid" element={<PermissionsEdit />} />

				{/* roles pages routes */}
				<Route path="/roles" element={<RolesList />} />
				<Route path="/roles/:fieldName/:fieldValue" element={<RolesList />} />
				<Route path="/roles/index/:fieldName/:fieldValue" element={<RolesList />} />
				<Route path="/roles/view/:pageid" element={<RolesView />} />
				<Route path="/roles/add" element={<RolesAdd />} />
				<Route path="/roles/edit/:pageid" element={<RolesEdit />} />

				{/* templetemaster pages routes */}
				<Route path="/templetemaster" element={<TempletemasterList />} />
				<Route path="/templetemaster/:fieldName/:fieldValue" element={<TempletemasterList />} />
				<Route path="/templetemaster/index/:fieldName/:fieldValue" element={<TempletemasterList />} />
				<Route path="/templetemaster/view/:pageid" element={<TempletemasterView />} />
				<Route path="/templetemaster/add" element={<TempletemasterAdd />} />
				<Route path="/templetemaster/edit/:pageid" element={<TempletemasterEdit />} />

				{/* users pages routes */}
				<Route path="/users" element={<UsersList />} />
				<Route path="/users/:fieldName/:fieldValue" element={<UsersList />} />
				<Route path="/users/index/:fieldName/:fieldValue" element={<UsersList />} />
				<Route path="/users/view/:pageid" element={<UsersView />} />
				<Route path="/users/add" element={<UsersAdd />} />
				<Route path="/users/edit/:pageid" element={<UsersEdit />} />
				<Route path="/sendmail" element={<SendmailPage />} />
				<Route path="/bulkupdatetemplete" element={<BulkupdatetempletePage />} />
				<Route path="/account/*" element={<AccountPages />} />
			</Route>
			</Route>
			<Route exact element={<IndexLayout />}>
				<Route path="/" element={<DefaultPage />} />
				<Route path="/*" element={<IndexPages />} />
				<Route path="/error/*" element={<ErrorPages />} />
			</Route>
		</Routes>
	);
}
export default App;
